import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import ExceptionsActionCreators from 'actions/ExceptionsActionCreators';
import ExceptionResolveModal from 'components/modules/exceptions/ExceptionResolveModal';
import ExceptionStore from 'stores/ExceptionStore';
import { humanize } from 'underscore.string';
import moment from 'moment';
import DataPoller from 'components/ui/DataPoller';
import Alert from 'components/ui/Alert';
import { sluggify } from 'utils/localization/utils';
import { withTranslation } from 'react-i18next';
import { getExceptionHighlightClassnames, shipmentExceptionAliases, } from '../../../helpers/exceptions';
const POLL = 9000;
class OpenExceptions extends Component {
    constructor(props) {
        super(props);
        // Provide a referenceable function to wrap _onChange
        // Using an anonymous function interfered with add/removeChangeListener
        this.callOnChange = () => {
            this._onChange();
        };
        this.handleResolve = (id, message, meta) => {
            ExceptionsActionCreators.addResolution(id, message, meta);
            this.queryExceptions();
        };
        this.handleResolveButtonClick = (exception) => () => this.setState({
            selectedException: exception,
            showResolveExceptionModal: true,
        });
        this.handleCloseResolveExceptionModal = () => this.setState({
            selectedException: null,
            showResolveExceptionModal: false,
        });
        this.state = {
            query: {
                page: 1,
                resourceId: props.shipment._id,
                resolved: false,
                pending_release: false,
            },
            exceptions: [],
            selectedException: null,
            showResolveExceptionModal: false,
            showPODException: typeof props.shipment.is_pod_valid === 'boolean' &&
                props.shipment.is_pod_valid === false,
        };
    }
    componentDidMount() {
        this.queryExceptions();
        ExceptionStore.addChangeListener(this.callOnChange);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.state.query.resourceId !== newProps.shipment._id) {
            const query = this.state.query;
            query.resourceId = newProps.shipment._id;
            this.setState({ query }, () => {
                this.queryExceptions();
            });
        }
        if (typeof newProps.shipment.is_pod_valid === 'boolean' &&
            this.props.shipment.is_pod_valid === false) {
            this.setState({ showPODException: true });
        }
    }
    componentWillUnmount() {
        ExceptionStore.removeChangeListener(this.callOnChange);
    }
    _onChange() {
        const exceptions = ExceptionStore.getAllExceptions();
        this.setState({ exceptions });
    }
    queryExceptions() {
        ExceptionsActionCreators.getExceptions(this.state.query);
    }
    renderExceptions() {
        const { t } = this.props;
        return this.state.exceptions.map((exception, i) => {
            return ((React.createElement("div", { "data-testid": `div-ecf14ce9-${i}`, key: i, className: 'mb-2 text-grey-darkest p-4 flex rounded shadow ' +
                    getExceptionHighlightClassnames(exception) },
                React.createElement("div", { "data-testid": `div-5bd5d2c6-${i}`, className: "w-1/6" },
                    React.createElement("span", { "data-testid": `span-95c8ffbf-${i}`, className: "" }, humanize(t(sluggify(shipmentExceptionAliases[exception.exception_type] ||
                        exception.exception_type))))),
                React.createElement("div", { "data-testid": `div-d58d7240-${i}`, className: "w-1/6" },
                    React.createElement("span", { "data-testid": `span-896c6f90-${i}`, className: "italic" }, moment(exception.release_time).fromNow())),
                React.createElement("div", { "data-testid": `div-469e086a-${i}`, className: "w-1/2" },
                    React.createElement("span", { "data-testid": `span-2625f98b-${i}`, className: "" }, t(exception.description))),
                React.createElement("div", { "data-testid": `div-99d89141-${i}`, className: "flex justify-end w-1/3" },
                    React.createElement("button", { "data-testid": `button-68de857b-${i}`, className: "button button-green", onClick: this.handleResolveButtonClick(exception) }, t('RESOLVE'))))));
        });
    }
    renderPODInvalid() {
        return ((React.createElement(Alert, { dataTestId: "Alert-564e2c34", title: "POD Verification Failed", type: "error" }, this.props.t('UNABLE_TO_VERIFY_POD'))));
    }
    render() {
        if (this.state.exceptions.length === 0 && !this.state.showPODException)
            return null;
        const { t } = this.props;
        return ((React.createElement("div", { "data-testid": "div-570980d9" },
            React.createElement(DataPoller, { dataTestId: "DataPoller-36da404e", action: () => this.queryExceptions(), frequency: POLL }),
            React.createElement("div", { "data-testid": "div-8ee53fcc", className: "mb-4 bg-white rounded-lg shadow" },
                this.state.exceptions.length ? (React.createElement("div", { "data-testid": "div-cbc10157", className: "flex" },
                    React.createElement("div", { "data-testid": "div-f1a746fd", className: "w-full p-4" },
                        React.createElement("h4", { "data-testid": "h4-94f7f7c9", className: "my-0 mb-4 text-grey-darker" },
                            t('UNRESOLVED_EXCEPTIONS'),
                            ' ',
                            React.createElement(Badge, null, this.state.exceptions.length)),
                        this.renderExceptions()))) : null,
                this.state.showPODException && this.renderPODInvalid(),
                this.state.showResolveExceptionModal && (React.createElement(ExceptionResolveModal, { exception: this.state.selectedException, onCancel: this.handleCloseResolveExceptionModal, onResolve: this.handleResolve, show: this.state.showResolveExceptionModal }))))));
    }
}
export default withTranslation()(OpenExceptions);
